<template>
    <div class="popup-overlay">
        <div class="popup-content">
            <div class="popup-header">
                <div class="popup_title">인감 비밀번호</div>
                <img src="@/assets/images/close_btn.png" @click="emit('closePop')" class="close_icon" />
            </div>
            <form @submit.prevent="submitPassword" autocomplete="off">
                <!-- 가짜 비밀번호 입력 필드 -->
                <input type="text" name="fake_user" style="display: none;" autocomplete="off" />
                <input type="password" name="fake_pwd" style="display: none;" autocomplete="off" />
                <!-- 실제 비밀번호 입력 필드 -->
                <input type="password" v-model="password" placeholder="비밀번호" autocomplete="new-password" />
                <button type="submit">확인</button>
            </form>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, defineEmits } from 'vue';

const emit = defineEmits(["passwordChk", "closePop"]);
const password = ref('');
const submitPassword = () => {
    emit("passwordChk", password.value)
        console.log(password.value)
}
</script>

<style scoped>

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 71px;
  border-bottom: 1px solid #dbdbdb;
}
.popup_title {
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.05em;
  color: black;
}
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
}

.popup-content {
    background: white;
    border-radius: 11px;
    text-align: center;
    padding: 22px 27px 22px 40px;
}

input {
    display: block;
    width: 100%;
    margin: 10px 0;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

button {
    padding: 10px 20px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

button:hover {
    background: #0056b3;
}
</style>